import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api, mensagemErro } from '../api';
import { useAuth } from '../auth';
import { Carregando, Erro, Icon, Progresso, STATUS_CAMPANHA } from '../components/ui';
import { data, dataHora } from '../format';

interface Linha {
  id: string; nome: string; status: string; totalClientes: number; iniciadaEm: string | null; dataFim: string | null;
  createdAt: string; criadoPorNome: string; enviados: number; pendentes: number; pendentesMeus: number; oportunidades: number;
}

export function CampanhasPage() {
  const { pode } = useAuth();
  const q = useQuery({ queryKey: ['campanhas'], queryFn: () => api<Linha[]>('/campanhas') });
  return (
    <>
      <div className="page-head">
        <div><h1>Campanhas</h1><span className="muted small">WhatsApp via wa.me — o vendedor envia e confirma cada mensagem.</span></div>
        <div className="actions">{pode('CAMPANHAS_CRIAR') && <Link className="btn primary" to="/campanhas/nova"><Icon name="mais" size={15} />Nova campanha</Link>}</div>
      </div>
      {q.error && <Erro erro={mensagemErro(q.error)} />}
      <div className="card flush">
        {q.isLoading ? <Carregando /> : !q.data?.length ? (
          <div className="empty">Nenhuma campanha ainda.<Link className="btn primary" to="/campanhas/nova">Criar a primeira</Link></div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead><tr><th>Campanha</th><th>Status</th><th style={{ width: 220 }}>Progresso</th><th>Oportunidades</th><th>Período</th><th></th></tr></thead>
              <tbody>
                {q.data.map((c) => {
                  const st = STATUS_CAMPANHA[c.status]!;
                  return (
                    <tr key={c.id}>
                      <td><Link to={`/campanhas/${c.id}`} style={{ color: 'var(--text)', display: 'flex', flexDirection: 'column' }}>
                        <span style={{ fontWeight: 500 }}>{c.nome}</span><span className="small faint">por {c.criadoPorNome} · {dataHora(c.createdAt)}</span></Link></td>
                      <td><span className={`badge ${st.cls}`}>{st.label}</span></td>
                      <td>{c.status === 'RASCUNHO' ? <span className="faint">—</span> : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                          <Progresso valor={c.enviados} total={c.totalClientes} />
                          <span className="small num muted">{c.enviados} de {c.totalClientes} enviados</span>
                        </div>
                      )}</td>
                      <td className="num">{c.oportunidades}</td>
                      <td className="num small">{c.iniciadaEm ? `${dataHora(c.iniciadaEm).slice(0, 5)}${c.dataFim ? ` → ${data(c.dataFim).slice(0, 5)}` : ''}` : '—'}</td>
                      <td style={{ textAlign: 'right' }}>
                        {c.status === 'EM_EXECUCAO' && c.pendentesMeus > 0
                          ? <Link className="btn primary sm" to={`/campanhas/${c.id}/fila`}>Abrir fila ({c.pendentesMeus})</Link>
                          : <Link className="btn sm" to={`/campanhas/${c.id}`}>{c.status === 'RASCUNHO' ? 'Revisar' : 'Ver'}</Link>}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
